/**
 * @prettier
 */
import React from "react";

import { AdminSettings } from "./AdminSettings";

export default React.memo(AdminSettings);
